module.exports = __webpack_public_path__ + "static/lisa-aiden-48461bc0098f4805f861c265ec456541.jpg";